export const deleteTrustedPhoneNumberKey = 'deleteTrustedPhoneNumber';
export const updateTrustedPhoneNumberKey = 'updateTrustedPhoneNumber';